export default __webpack_public_path__ + "static/media/HoveringCube.6857e760.riv";